module.exports = __webpack_public_path__ + "static/NW_KP_Bild_Portr_1_a_Eng-c8499a48c6dfa7f76b22175472454e32.jpg";